import { useColorMode } from '@chakra-ui/react';
import { useCallback } from 'react';

import { ResponsiveStyleValue } from '../types/style';

export const useColorModeStyle = () => {
	const { colorMode } = useColorMode();

	const mode = useCallback((lightValue: ResponsiveStyleValue, darkValue: ResponsiveStyleValue) => (colorMode === 'dark' ? darkValue : lightValue), [colorMode]);

	return { colorMode, mode };
};
